/**
 * @author SoulHarsh007 <harshtheking@hotmail.com>
 * @copyright SoulHarsh007 2021
 * @see https://github.com/SoulHarsh007/helpertux/blob/main/utils/stopWatch.js
 * @see https://github.com/SoulHarsh007/helpertux/blob/69485f33e9fc68827f190f21cc8e115bbece2572/utils/stopWatch.js
 * @see https://github.com/SoulHarsh007/helpertux/blob/main/LICENSE
 * @class StopWatch
 * @license BSD-3-Clause
 *
 * Copyright (c) 2021, SoulHarsh007
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its
 *    contributors may be used to endorse or promote products derived from
 *    this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */
export class StopWatch {
  /**
   * @class
   */
  constructor() {
    this._start = performance.now();
    this._end = null;
  }

  /**
   * @returns {number} returns duration
   */
  get duration() {
    return this._end
      ? this._end - this._start
      : performance.now() - this._start;
  }

  /**
   * @returns {boolean} returns true if running else false
   */
  get running() {
    return !this._end;
  }

  /**
   * @function restart
   * @returns {StopWatch} returns restarted stopwatch instance
   */
  restart() {
    this._start = performance.now();
    this._end = null;
    return this;
  }

  /**
   * @function reset
   * @returns {StopWatch} resets and returns stopwatch instance
   */
  reset() {
    this._start = performance.now();
    this._end = this._start;
    return this;
  }

  /**
   * @function start
   * @returns {StopWatch} returns started stopwatch instance
   */
  start() {
    if (!this.running) {
      this._start = performance.now() - this.duration;
      this._end = null;
    }
    return this;
  }

  /**
   * @function stop
   * @returns {StopWatch} returns stopped stopwatch instance
   */
  stop() {
    if (this.running) {
      this._end = performance.now();
    }
    return this;
  }

  /**
   * @function toString
   * @returns {string} returns time elapsed in string format
   */
  toString() {
    const time = this.duration;
    if (time >= 1000) {
      return `${(time / 1000).toFixed(3)}s`;
    }
    if (time >= 1) {
      return `${time.toFixed(3)}ms`;
    }
    return `${(time * 1000).toFixed(3)}μs`;
  }
}
